<app-tab-bar [tabs]="tabList" [currentTab]="'trs calculator'" (updateCurrentIndex)="openTab($event)"></app-tab-bar>
<div class="site-content">
  <div class="section">
    <div class="sub-section" style="margin-top: 10px">
      <div class="tab">
        <span class="tablinks" [ngClass]="{'activeTab': currentView === 'Disclaimer'}" (click)="currentView = 'Disclaimer'">Disclaimer</span>
        <span class="tablinks" [ngClass]="{'activeTab': currentView === 'Upfront & Coupon calculator'}" (click)="currentView = 'Upfront & Coupon calculator'">Upfront & Coupon Calculator</span>
        <span class="tablinks" [ngClass]="{'activeTab': currentView === 'Unwind calculator'}" (click)="currentView = 'Unwind calculator'">Unwind Calculator</span>
      </div>
    </div>
    <div class="sub-section" *ngIf="currentView === 'Disclaimer'">
      Neither S&P Dow Jones Indices, its affiliates or any third party data provider makes any warranty, express or implied, as to the accuracy, completeness or timeliness of the data and calculator contained herewith nor as to the results to be obtained by recipients using the data and/or the calculator. Neither S&P Dow Jones Indices, its affiliates nor any data provider shall in any way be liable to any recipient of the data for any inaccuracies, errors or omissions in the S&P Dow Jones Indices data or the calculator, regardless of cause, or for any damages (whether direct or indirect) resulting therefrom.
      S&P Dow Jones Indices has no obligation to update, modify or amend the data or the calculator or to otherwise notify a recipient thereof in the event that any matter stated herein changes or subsequently becomes inaccurate.
      The data and the calculator should be used for internal reference use only, and any other use of the S&P Dow Jones Indices data or the calculator is prohibited including but not limited to distributing, transferring, licensing, renting, lending, transmitting, selling, repackaging, leasing, publishing or otherwise distributing or making available all or any portion of the S&P Dow Jones Indices data by any means to any other person or entity.
      Without limiting the foregoing, S&P Dow Jones Indices, its affiliates, or any third party data provider shall have no liability whatsoever to you, whether in contract (including under an indemnity), in tort (including negligence), under a warranty, under statute or otherwise, in respect of any loss or damage suffered by you as a result of or in connection with any opinions, recommendations, forecasts, judgments, or any other conclusions, or any course of action determined, by you or any third party, whether or not based on the content, information or materials contained herein.
      Copyright © 2023, S&P Dow Jones Indices.
    </div>
    <div class="sub-section" *ngIf="currentView !== 'Disclaimer'" style="display: flex">
      <div style="width: 30%; margin-right: 10px">
        <table class="custom-table-striped">
          <tbody>
          <tr>
            <td class="heading">Calculation method</td>
            <td style="padding-right: 5px">Accrual Method</td>
          </tr>
          </tbody>
          <tbody class="input-section">
          <tr>
            <td class="heading">Input</td>
            <td></td>
          </tr>
          <tr>
            <td>Currency</td>
            <td>
              <div style="width: 78%; float: right">
                <app-ihsm-dropdown-lib dropdownType="single" [data]="currency" (filterAppliedEvent)="changeHeader($event)"></app-ihsm-dropdown-lib>
              </div>
            </td>
          </tr>
          <tr>
            <td *ngIf="currentView === 'Upfront & Coupon calculator'">Trade Date (T)</td>
            <td *ngIf="currentView === 'Unwind calculator'">Unwind Trade Date (T)</td>
            <td>
              <input type="text" [placeholder]="tradeDateToDisplay" (click)="openPicker('tradeDate')">
              <input type="date" id="tradeDate" class="hidden-element" [(ngModel)]="tradeDate" [min]="min" [max]="today" (ngModelChange)="tradeDateChanged()">
            </td>
          </tr>
          <tr>
            <td>Maturity Date</td>
            <td>
              <div style="width: 78%; float: right">
                <app-ihsm-dropdown-lib dropdownType="single" [data]="IMMDate"
                                       (filterAppliedEvent)="IMMDateChanged($event)"></app-ihsm-dropdown-lib>
              </div>
            </td>
          </tr>
          <tr>
            <td>Notional</td>
            <td>
              <div class="input-group-btn">
                <input type="text" style="flex-grow: 1; width: 100%" id="notional" [(ngModel)]="notional" (ngModelChange)="notionalModelChange()" (keydown)="validateNumber($event)" (keypress)="formatNotional($event)">
              </div>
            </td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'">
            <td>Initial Index Level</td>
            <td>
              <div class="input-group-btn">
                <input type="text" style="flex-grow: 1; width: 100%" id="initialIndexLevel" [(ngModel)]="initialIndexLevel" (ngModelChange)="initialIndexLevelModelChange()" (keydown)="validateNumber($event)" (keypress)="formatNotional($event)">
              </div>
            </td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'">
            <td>Final Index Level</td>
            <td>
              <div class="input-group-btn">
                <input type="text" style="flex-grow: 1; width: 100%" id="finalIndexLevel" [(ngModel)]="finalIndexLevel" (ngModelChange)="finalIndexLevelModelChange()" (keydown)="validateNumber($event)" (keypress)="formatNotional($event)">
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding: 0;">
              <button class="btn-calculate" *ngIf="currentView === 'Upfront & Coupon calculator'"
                      [ngStyle]="{'background': validTradeDate && notional.length > 0 ? 'green' : 'grey'}" (click)="formatNotional($event)">CALCULATE</button>
              <button class="btn-calculate" *ngIf="currentView === 'Unwind calculator'"
                      [ngStyle]="{'background': validTradeDate && notional.length > 0 && initialIndexLevel.length > 0 && finalIndexLevel.length > 0 ? 'green' : 'grey'}"
                      (click)="formatNotional($event)">CALCULATE</button>
            </td>
          </tr>
          </tbody>
          <tbody *ngIf="showOutput">
          <tr>
            <td class="heading">Output</td>
            <td></td>
          </tr>
          <tr>
            <td>Prior IMM Date</td>
            <td>
              <input type="text" [placeholder]="priorIMMDate" (click)="openPicker('priorIMMDate')" disabled>
              <input type="date" id="priorIMMDate" class="hidden-element" [(ngModel)]="priorIMMDate" (ngModelChange)="priorIMMDateChanged()" >
            </td>
          </tr>
          <tr>
            <td>Prior IMM Date - 2bd</td>
            <td>
              <input type="text" [placeholder]="priorIMMDateDiff" (click)="openPicker('priorIMMDateDiff')" disabled>
              <input type="date" id="priorIMMDateDiff" class="hidden-element" [(ngModel)]="priorIMMDateDiff" (ngModelChange)="priorIMMDateDiffChanged()" >
            </td>
          </tr>
          <tr *ngIf="calcType === 'EUR'">
            <td>3M Euribor (Prior IMM Date - 2bd)</td>
            <td><input type="text" [(ngModel)]="prevEuribor" (ngModelChange)="euriborChanged()" disabled></td>
          </tr>
          <tr *ngIf="calcType === 'USD'" class="dynamic-row">
            <td>SOFRAI (Prior IMM Date - 2bd)</td>
            <td><input type="text" [(ngModel)]="previousSofrai" (ngModelChange)="sofraiChanged()" disabled></td>
          </tr>
          <tr *ngIf="calcType === 'USD'">
            <td>T-1</td>
            <td>
              <input type="text" [placeholder]="previousDate" (click)="openPicker('previousDate')" disabled>
              <input type="date" id="previousDate" class="hidden-element" [(ngModel)]="previousDate" (ngModelChange)="previousDateChanged()" >
            </td>
          </tr>
          <tr *ngIf="calcType === 'USD'">
            <td>SOFRAI (T-1)</td>
            <td><input type="text" [(ngModel)]="sofrai" (ngModelChange)="previousSofraiChanged()" disabled></td>
          </tr>
          <tr>
            <td>Next IMM Date</td>
            <td>
              <input type="text" [placeholder]="nextIMMDate" (click)="openPicker('nextIMMDate')" disabled>
              <input type="date" id="nextIMMDate" class="hidden-element" [(ngModel)]="nextIMMDate" (ngModelChange)="nextDateChanged()" >
            </td>
          </tr>
          <tr *ngIf="calcType === 'USD'">
            <td>Next IMM Date - 2bd</td>
            <td>
              <input type="text" [placeholder]="nextIMMDateDiff" (click)="openPicker('nextIMMDateDiff')" disabled>
              <input type="date" id="nextIMMDateDiff" class="hidden-element" [(ngModel)]="nextIMMDateDiff" (ngModelChange)="nextIMMDateDiffChanged()" >
            </td>
          </tr>
          <tr *ngIf="calcType === 'USD'" class="dynamic-row">
            <td>SOFRAI (Next IMM Date - 2bd)</td>
            <td><input type="text" [(ngModel)]="nextSofrai" (ngModelChange)="nextSofraiChanged()" disabled></td>
          </tr>
<!--          REMOVED AS PER IDXBAU-9124-->
<!--          <tr *ngIf="calcType === 'EUR'">-->
<!--            <td>3M Euribor (Next IMM Date - 2bd)</td>-->
<!--            <td><input type="text" [(ngModel)]="nextEuribor" (ngModelChange)="nextEuriborChanged()" disabled></td>-->
<!--          </tr>-->
          </tbody>
          <tbody class="output-section" *ngIf="showOutput">
          <tr>
            <td>Effective Date </td>
            <td><input type="text" [(ngModel)]="effectiveDate" disabled></td>
          </tr>
          <tr>
            <td>Accrued Floating Rate</td>
            <td><input type="text" [(ngModel)]="accruedFloatingRate" disabled></td>
          </tr>
          <tr style="background: #b3e6cc;">
            <td>Accrued Amount </td>
            <td><input type="text" [(ngModel)]="accruedAmount" disabled></td>
          </tr>
          <tr *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>First Coupon Date </td>
            <td><input type="text" [(ngModel)]="firstCouponDate" disabled></td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'" style="background: #b3e6cc">
            <td>Performance Leg</td>
            <td><input type="text" [(ngModel)]="performanceLeg" disabled></td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'" style="background: #d9f2e5;">
            <td>Trade Value </td>
            <td><input type="text" [(ngModel)]="tradeValue" disabled></td>
          </tr>
          <tr *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>Coupon Floating Rate </td>
            <td><input type="text" [(ngModel)]="couponFloatingRate" disabled></td>
          </tr>
          <tr style="background: #b3e6cc;" *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>First Coupon Amount </td>
            <td><input type="text" [(ngModel)]="firstCouponAmount" disabled></td>
          </tr>
          <tr *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>Last Coupon Date </td>
            <td><input type="text" [(ngModel)]="lastCouponDate" disabled></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="width: 70%">
        <table class="custom-table-striped description-table" style="table-layout: auto">
          <tbody>
          <tr>
            <td>Calculation Method Utilized to Value Standardized TRS</td>
            <td></td>
          </tr>
          </tbody>
          <tbody>
          <tr class="first-blank-row">
            <td></td>
            <td></td>
          </tr>
          <tr class="blank-row">
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Date for entering into new trade - Insert any business date from 20th March 2020 to Present Date</td>
            <td></td>
            <lib-ihsm-alert-notification class="calc-page-alert-box" *ngIf="showAlert1" [message]="alert1" (close)="showAlert1 = false" [messageType]="'warning'"></lib-ihsm-alert-notification>
          </tr>
          <tr>
            <td>Maturity date of the iBoxx TRS contract - IMM date equal to or no later than next IMM date 2 years after Trade Date</td>
            <td></td>
          </tr>
          <tr>
            <td>Economic Value Referenced for Original Trade</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'">
            <td>Index Level at entry date</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'">
            <td>Index Level at Unwind Trade Date/Final Fixing Date</td>
            <td></td>
          </tr>
          <tr class="blank-row">
            <td></td>
            <td></td>
          </tr>
          </tbody>
          <tbody *ngIf="showOutput">
          <tr class="first-blank-row">
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Start date for current accrual period</td>
            <td></td>
          </tr>
          <tr>
            <td>Start date of current accrual period minus 2 business days</td>
            <td></td>
          </tr>
          <tr class="dynamic-row">
            <td *ngIf="calcType === 'USD'">SOFR index level as of 2 business days prior to start date for current accrual period</td>
            <td *ngIf="calcType === 'EUR'">3M Euribor as of 2 business days prior to start date for current accrual period</td>
            <td></td>
          </tr>
          <tr *ngIf="calcType === 'USD'">
            <td>Trade date minus 1 business day</td>
            <td></td>
          </tr>
          <tr *ngIf="calcType === 'USD'">
            <td>SOFR Index Level as of one business day prior to trade date</td>
            <td></td>
          </tr>
          <tr>
            <td>End date for current accrual period</td>
            <td></td>
          </tr>
          <tr *ngIf="calcType === 'USD'">
            <td>End date of current accrual period minus 2 business days</td>
            <td></td>
          </tr>
          <tr>
            <td *ngIf="calcType === 'USD'" class="dynamic-row">SOFR index level as of 2 business days prior to end date for current accrual period</td>
            <!--          REMOVED AS PER IDXBAU-9124-->
<!--            <td *ngIf="calcType === 'EUR'">3M Euribor as of 2 business days prior to end date for current accrual period</td>-->
            <td></td>
          </tr>
          </tbody>
          <tbody *ngIf="showOutput">
          <tr>
            <td>Trade date plus 1 calendar day</td>
            <td></td>
          </tr>
          <tr>
            <td *ngIf="currentView === 'Upfront & Coupon calculator'">Rate to be used to calculate upfront amount</td>
            <td *ngIf="currentView === 'Unwind calculator'">Rate to be used to calculate unwind amount</td>
            <td></td>
          </tr>
          <tr>
            <td *ngIf="currentView === 'Upfront & Coupon calculator'">Upfront Amount received to enter into long position</td>
            <td *ngIf="currentView === 'Unwind calculator'">Unwind amount paid to unwind long position</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'">
            <td>Index performance component</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Unwind calculator'">
            <td>Trade value at unwind/maturity</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>First full coupon payment date</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>Rate to be used to calculate First Coupon Amount</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>First full coupon payment amount</td>
            <td></td>
          </tr>
          <tr *ngIf="currentView === 'Upfront & Coupon calculator'">
            <td>Last coupon payment date</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
